import {API_PRACTICE} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const getPracticeByDeptId = async (deptId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_PRACTICE}/${deptId}`,
    });
    return res.data;
  } catch (error) {
    console.error('practiceApi getPracticeByDeptId Error:', error.message);
    return null;
  }
};

const practiceApi = {
  getPracticeByDeptId,
};

export default practiceApi;
